import { ReactNode, useState } from 'react';
import { Box, useHoverable } from '@gemini/core';
import { ExclamationCircleIcon } from '@gemini/icons';

const Popover = ({
    children,
    label,
    name,
    iconButtonAriaDescribedby,
}: {
    children: ReactNode;
    label?: string;
    name: string;
    iconButtonAriaDescribedby: string;
}) => {
    const [displayed, setDisplayed] = useState(false);
    const { boxProps, isHovered } = useHoverable();

    const toggleDisplayed = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setDisplayed(!displayed);
    };

    return (
        <Box position="relative">
            {(isHovered || displayed) && (
                <Box
                    position="absolute"
                    bottom="spacing.40"
                    display="flex"
                    alignItems="flexStart"
                    testId="popover-alert"
                    padding="spacing.12"
                    borderRadius="radius.4"
                    borderWidth="borderWidth.1"
                    borderStyle="solid"
                    borderColor="color.border.status.information.default"
                    backgroundColor="color.surface.status.information.default"
                >
                    {children}
                </Box>
            )}
            <Box display="flex" alignItems="baseline">
                {label && (
                    <Box
                        as="label"
                        paddingVertical="spacing.4"
                        marginRight="spacing.2"
                        typography="typography.body.14.bold"
                    >
                        {label}
                    </Box>
                )}
                <Box
                    {...boxProps}
                    testId={`${name}Information`}
                    as="button"
                    onClick={toggleDisplayed}
                    borderWidth="borderWidth.none"
                    aria-label="information"
                    aria-describedby={iconButtonAriaDescribedby}
                    outlineColor="color.border.interactive.default"
                >
                    <ExclamationCircleIcon
                        testId="popover-icon"
                        color="color.content.interactive.default"
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default Popover;
